import { InputField } from '../common/InputField'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { CorePersonalFields } from 'common/types/CorePersonalFields'
import * as yup from 'yup'

export const schemaCorePersonalFields = yup.object().shape({
  firstName: yup.string().required('Please enter your first name'),
  lastName: yup.string().required('Please enter your last name'),
  emailAddress: yup
    .string()
    .email('Please enter a valid email address')
    .required('Please enter an email connected to an account'),
  phoneNumber: yup.string().required('Please enter your phone number'),
})

interface CorePersonalFieldsPartialProps {
  className?: string
}

export const CorePersonalFieldsPartial = ({
  className,
}: CorePersonalFieldsPartialProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<CorePersonalFields>()

  return (
    <div className={className}>
      <InputField<CorePersonalFields>
        register={register}
        id='firstName'
        label='* First name'
        placeholder='firstName'
        errors={errors}
        errorMessage={errors.firstName?.message}
      />
      <InputField<CorePersonalFields>
        register={register}
        id='lastName'
        label='* Last name'
        placeholder='lastName'
        errors={errors}
        errorMessage={errors.lastName?.message}
      />
      <InputField<CorePersonalFields>
        register={register}
        id='emailAddress'
        label='* Email address'
        placeholder='emailAddress'
        errors={errors}
        errorMessage={errors.emailAddress?.message}
      />
      <InputField<CorePersonalFields>
        register={register}
        id='phoneNumber'
        label='* Phone number'
        placeholder='phoneNumber'
        errors={errors}
        errorMessage={errors.phoneNumber?.message}
      />
    </div>
  )
}
